import React from 'react';
import CompanyDetailsCard from './company_details/CompanyDetailsCard';
import HighlightedModuleCards from './billing/HighlightedModuleCards';
import '../../style/scss/navigation.scss';

const CompanyDetailsPage: React.FC = () => {
    return (
        <div className='container-filled align-center'>
            <div className='width-100'>
                <div className='medium-width align-center'>
                    <CompanyDetailsCard />
                    <HighlightedModuleCards />
                </div>
            </div>
        </div>
    );
};

export default CompanyDetailsPage;
